import React from 'react';
import {Route} from 'react-router-dom';
import AsyncHome from './async';
import DefaultBusinessLayout from '../../../components/layout/DefaultBusinessLayout';

export default [
  <Route
    key="/business"
    element={
      <DefaultBusinessLayout
        breadcrumb={[
          {
            position: 1,
            name: 'Home',
            item: '/business',
          },
        ]}
      />
    }
  >
    <Route path="business" element={<AsyncHome />} />
  </Route>,
];
